import { render, staticRenderFns } from "./LvToggleChip.vue?vue&type=template&id=e88a62b2"
import script from "./LvToggleChip.vue?vue&type=script&lang=js"
export * from "./LvToggleChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports